import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@storable/canaveral-components';
import { object, string } from 'yup';
import gql from 'graphql-tag';
import withForm from '../../hocs/withForm';
import formatInitialValues from '../../lib/formatInitialValues';
import FormFieldText from '../FormFieldText';
import styles from './styles.scss';

const propTypes = {
  dirty: PropTypes.bool.isRequired,
  isValid: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  handleReset: PropTypes.func.isRequired,
  navigationItem: PropTypes.shape({
    text: PropTypes.string.isRequired,
  }),
  onCancel: PropTypes.func.isRequired,
};

const defaultProps = {
  navigationItem: undefined,
};

const validationSchema = object().shape({
  text: string().required('Name is required'),
});

const initialValues = {
  text: '',
};

const NavigationGroupForm = ({
  navigationItem,
  dirty,
  handleSubmit,
  handleReset,
  isValid,
  onCancel,
}) => (
  <form onSubmit={handleSubmit} onReset={handleReset}>
    <FormFieldText
      required
      name="text"
      label="Name"
    />
    <div className={styles.buttons}>
      <Button context="neutral" onClick={onCancel}>
        Cancel
      </Button>
      <Button
        context="positive"
        disabled={!dirty || !isValid}
        type="submit"
      >
        {navigationItem ? 'Save' : 'Add'}
      </Button>
    </div>
  </form>
);

NavigationGroupForm.propTypes = propTypes;
NavigationGroupForm.defaultProps = defaultProps;

NavigationGroupForm.fragments = {
  navigationItem: gql`
    fragment NavigationGroupFormNavigationItem on NavigationItem {
      text
    }
  `,
};

export default withForm({
  mapPropsToValues: ({ navigationItem }) => formatInitialValues(initialValues, navigationItem),
  handleSubmit: (navigationItem, formikBag) => formikBag.props.onSubmit(navigationItem),
  validationSchema,
})(NavigationGroupForm);
